import { AppService } from "@/services/appService";
import anime from "animejs";

export interface phoneBlockForm {
  code: string;
  number: string;
  submitUrl: string;
  id: string;
}

export default {
  data() {
    return {
      AppService,
      phoneBlockValidationError: false,
      phoneBlockLoading: false,
      phoneBlockSubmitted: false,
      phoneData: {},
      phoneValues: {},
      showCountryDropdown: null as string | null,
      phoneInputError: {},
    };
  },
  methods: {
    phoneBlockCountryClick(id: string) {
      const self = this as any;
      self.showCountryDropdown = id;
    },
    phoneBlockCountryClose() {
      const self = this as any;
      self.showCountryDropdown = null;
    },
    phoneBlockCountrySelect(
      id: string,
      country: {
        country_code: string;
        name: string;
        phone_code: string;
      }
    ) {
      const self = this as any;
      self.phoneData = { ...self.phoneData, [id]: { ...self.phoneData[id], country } };
    },
    phoneBlockNumberUpdate(id: string, event: any) {
      const self = this as any;
      const nationalNumber = event.target.value;
      if (nationalNumber === " ") {
        self.phoneValues[id] = "";
        return;
      }

      self.phoneInputError[id] = null;

      const numericValue = nationalNumber.replace(/[^\d\s]/g, "").replace(/(\d{3})(?=\d)/g, "$1 ");

      self.phoneValues[id] = numericValue;

      self.phoneData = {
        ...self.phoneData,
        [id]: { ...self.phoneData[id], nationalNumber: nationalNumber.replace(/\s+/g, "") },
      };
    },
    phoneBlockClick(id: string, submitUrl = "") {
      const self = this as any;
      const container = document.querySelector("#phone-block-" + id);
      const phoneData = self.phoneData[id];
      if (!self.phoneBlockLoading) {
        if (container) {
          if (phoneData?.nationalNumber) {
            if (phoneData.nationalNumber.match(self.phoneData[id]?.country?.regex ?? "^\\d{9}$") !== null) {
              const subs = self.AppService.phoneBlockSubjectResult.subscribe((d: any) => {
                self.phoneBlockLoading = false;
                self.phoneValues[id] = "";
                self.phoneInputError[id] = null;
                subs.unsubscribe();
              });
              self.phoneBlockLoading = true;
              self.AppService.phoneBlockSubject.next({
                code: self.phoneData[id]?.country?.phone_code ?? "+420",
                number: self.phoneData[id]?.nationalNumber,
                submitUrl,
                id,
              });
              self.phoneBlockSubmitted = true;
            } else {
              self.phoneInputError[id] = "Telefonní číslo nemá správnou délku";
            }
          } else {
            self.phoneInputError[id] = "Vyplňte prosím telefonní číslo";
          }
        }
      }
    },
    animate(params: anime.AnimeParams, opts?: anime.AnimeParams) {
      if (opts) {
        params = { ...params, ...opts };
      }
      return anime(params).finished;
    },
    animateAll(paramsObjects: { [key: string]: anime.AnimeParams }, opts?: anime.AnimeParams) {
      const array = [];
      for (const i in paramsObjects) {
        if (Object.prototype.hasOwnProperty.call(paramsObjects, i)) {
          array.push(paramsObjects[i]);
        }
      }
      return this.animateArray(array, opts);
    },
    animateArray(paramsArray: anime.AnimeParams[], opts?: anime.AnimeParams) {
      if (opts) {
        for (const key in paramsArray) {
          paramsArray[key] = { ...paramsArray[key], ...opts };
        }
      }
      const arr = [];
      for (const i of paramsArray) {
        arr.push(anime(i).finished);
      }
      return Promise.all(arr);
    },
  },
};
